import React from 'react';
import Explore from 'components/modules/master/Explore';
import { useFlags } from 'launchdarkly-react-client-sdk';

function UnifiedViewFlagWrapper(props) {
  const flags = useFlags();
  const enableOrdersUnifiedView = flags?.enableOrdersUnifiedView;
  return (
    <Explore {...props} enableOrdersUnifiedView={enableOrdersUnifiedView} />
  );
}

export default UnifiedViewFlagWrapper;
